import { Fragment, useContext, useState } from "react";
import { ParagraphText } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import { formatNum } from "../../../../oscar-pos-core/constants";
import { Box, CircularProgress } from "@mui/material";
import { PopoverMenu } from "../../../common";
import {
  DeleteNewIcon,
  DownloadIcon,
  EditIcon,
  PrintIcon,
} from "../../../../assets/icons/icon";

import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { useAuthContext } from "../../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import useDownlaodPdf from "../../../../hooks/useDownlaodPdf";
import DeleteAccount from "../DeleteAccount";
import { getDueInfo } from "../../../../utils";

const ItemList = ({
  accountDetail,
  key,
  onSelect = () => {},
  onEdit = () => {},
  onDeleteSuccess = () => {},
  index,
  filters,
}) => {
  const [I18n] = useContext(LanguageContext);
  const [open, setOpen] = useState(false);
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const { onDownload, downloadLoading } = useDownlaodPdf(user);

  const isByOthers = Boolean(filters?.customers?.toLowerCase() == "by others");

  const handleDownload = async (isHtml = false) => {
    let paramsForReport = {
      name: `${accountDetail.name.toLowerCase()}_mini_statement.pdf`,
      template_name: "accountreport.hbs",
      customer_id: accountDetail.id,
      type: isByOthers ? "shared-mini" : "mini",
      pdf: !isHtml,
      html: isHtml,
      supplier: isByOthers ? false : accountDetail.is_supplier,
    };
    onDownload(paramsForReport, onSuccessDownload, navigate);
  };
  const onSuccessDownload = (res) => {
    if (res.type === "text/html") {
      const url = URL.createObjectURL(res);
      const iframe = document.createElement("iframe");
      iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:1px;height:1px;border:0;";
      document.body.appendChild(iframe);
      iframe.src = url;
      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        window.addEventListener("afterprint", function cleanup() {
          document.body.removeChild(iframe);
          URL.revokeObjectURL(url);
          window.removeEventListener("afterprint", cleanup);
        });
      };
    }
  };

  const AccoountActions = [
    ...(!isByOthers
      ? [
          {
            label: (
              <Fragment>
                <EditIcon width={20} height={20} />
                <ParagraphText className="textCapitalizeFirstLetter">
                  {I18n.edit}
                </ParagraphText>
              </Fragment>
            ),
            hideOnPaid: true,
            action: (e) => {
              triggerLogEvent(analytics, "acc_options_edit", {});
              e.stopPropagation();
              onEdit();
            },
          },
        ]
      : []),
    {
      label: (
        <Fragment>
          <PrintIcon width={20} height={20} />
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n.print}
          </ParagraphText>
        </Fragment>
      ),
      action: (e) => {
        triggerLogEvent(analytics, "acc_options_print");
        handleDownload(true);
        e.stopPropagation();
      },
    },
    {
      label: (
        <Fragment>
          <DownloadIcon width={20} height={18} id="download_black_btn" />
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n.download_pdf}
          </ParagraphText>
        </Fragment>
      ),
      action: (e) => {
        triggerLogEvent(analytics, "acc_options_download", {});
        handleDownload();
        e.stopPropagation();
      },
    },
    ...(!isByOthers
      ? [
          {
            label: (
              <Fragment>
                <DeleteNewIcon
                  width={20}
                  height={18}
                  id="download_black_btn"
                />
                <ParagraphText className="textCapitalizeFirstLetter">
                  {I18n.delete}
                </ParagraphText>
              </Fragment>
            ),
            action: (e) => {
              triggerLogEvent(analytics, "acc_options_delete", {});
              deletePrompt();
              e.stopPropagation();
            },
          },
        ]
      : []),
  ];

  const deletePrompt = () => {
    setOpen(true);
    return;
  };

  const dueInfo = !(accountDetail.total_outstanding_payment > 0)
    ? getDueInfo(accountDetail?.payment_at)
    : getDueInfo(accountDetail?.collect_at);

  const isBalanceGreen = !(
    isByOthers
      ? accountDetail.total_outstanding_payment < 0
      : accountDetail.total_outstanding_payment > 0
  );

  return (
    <Box
      className="invoiceListTableBody accountTableHeaderMain"
      key={index}
      id={`${accountDetail.is_supplier ? "supp" : "cust"}_${index}`}
      onClick={(e) => {
        if (open) return;
        e.stopPropagation();
        onSelect();
      }}
    >
      <Box
        className={`invListTableHeaderCol fiveColumn textLeft sidebarOption`}
      >
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {accountDetail.name}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {accountDetail?.phone || "-"}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol fiveColumn textLeft`}>
        <ParagraphText
          className={`fontSize14 fontWeight400 truncateOneLine textLeft ${
            dueInfo.isPast ? "redColor" : "newFontColor"
          }`}
        >
          {dueInfo.text}
        </ParagraphText>
      </Box>
      <Box
        className={`invListTableHeaderCol fiveColumn textRight amountColumnNewWrapper`}
      >
        <ParagraphText
          className={`fontSize14 fontWeight400 truncateOneLine textRight ${isBalanceGreen ? "foundationGreenColor" : "foundationOrangeColor"}`}
        >
            <span className="marginRight2">Rs.</span>
            <span>{formatNum(Math.abs(accountDetail.total_outstanding_payment) || 0)}</span>
          
         
        </ParagraphText>
      </Box>
      <Box className={`amountColumnInnerWrapper textCenter invListTableHeaderCol fiveColumn textCenter`}>
        <div className="tblOptnBox" role="button">
          <PopoverMenu
            id="account_list"
            menuOptions={AccoountActions}
            popOverStyle={{
              marginLeft: "5px",
              borderRadius: "16px !important",
            }}
            popoverButton={
              downloadLoading && <CircularProgress size={"15px"} />
            }
            disabled={downloadLoading}
          />
        </div>
      </Box>
      <DeleteAccount
        customer={accountDetail}
        onDeleteSuccess={onDeleteSuccess}
        open={open}
        setOpen={setOpen}
      />


    </Box>
  );
};

export default ItemList;
